export default {
  // Endpoints
  loginEndpoint: `${process.env.VUE_APP_URL}/api/v1/auth/jwt/create`,
  getUser: `${process.env.VUE_APP_URL}/api/v1/auth/users/me/`,
  getUserSettings: `${process.env.VUE_APP_URL}/api/v1/auth/users/me/settings`, // TO CHANGE
  registerEndpoint: '/jwt/register',
  refreshEndpoint: `${process.env.VUE_APP_URL}/api/v1/auth/jwt/refresh`,
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
